import { render, staticRenderFns } from "./image-slider.vue?vue&type=template&id=74cf2f46&scoped=true&"
import script from "./image-slider.vue?vue&type=script&lang=ts&"
export * from "./image-slider.vue?vue&type=script&lang=ts&"
import style0 from "./image-slider.vue?vue&type=style&index=0&id=74cf2f46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cf2f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74cf2f46')) {
      api.createRecord('74cf2f46', component.options)
    } else {
      api.reload('74cf2f46', component.options)
    }
    module.hot.accept("./image-slider.vue?vue&type=template&id=74cf2f46&scoped=true&", function () {
      api.rerender('74cf2f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/estates/image-slider.vue"
export default component.exports